module.exports = __webpack_public_path__ + "4085ce2e77bfee59a522e7ec9f84d808.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/elephant-poster.png
// module id = 1603
// module chunks = 0